import { render, staticRenderFns } from "./ProjectListFilter.vue?vue&type=template&id=b89a20f4&scoped=true&"
import script from "./ProjectListFilter.vue?vue&type=script&lang=js&"
export * from "./ProjectListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89a20f4",
  null
  
)

export default component.exports